import React, { useState } from "react";
import { Star, Quote, ChevronLeft, ChevronRight } from "lucide-react";
import { TESTIMONIALS } from "../mock";
import Reveal from "./Reveal";

const initials = (name) => name.split(" ").map((n) => n[0]).join("").slice(0, 2).toUpperCase();
const colors = ["#1B4B82", "#F5941F", "#237BF6", "#2ecc71"];

const TestimonialsSection = () => {
  const [active, setActive] = useState(0);
  const move = (dir) => setActive((a) => (a + dir + TESTIMONIALS.length) % TESTIMONIALS.length);

  return (
    <section className="py-16 sm:py-20 bg-[#f7f9fc]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <Reveal className="text-center mb-12 max-w-3xl mx-auto">
          <span className="text-orange-brand font-bold text-sm uppercase tracking-wide">Our Customers Say</span>
          <h2 className="text-3xl sm:text-4xl font-bold text-navy font-head mt-2">Rated 4.5+ by 4.12L Happy Customers</h2>
          <div className="flex justify-center gap-1 mt-3">
            {[...Array(5)].map((_, i) => <Star key={i} size={20} className="text-orange-brand" fill="#F5941F" />)}
          </div>
        </Reveal>

        {/* Desktop grid */}
        <div className="hidden md:grid grid-cols-2 lg:grid-cols-4 gap-6">
          {TESTIMONIALS.map((t, i) => <Card key={t.name} t={t} i={i} delay={i * 60} />)}
        </div>

        {/* Mobile carousel */}
        <div className="md:hidden">
          <Card t={TESTIMONIALS[active]} i={active} />
          <div className="flex items-center justify-center gap-4 mt-6">
            <button onClick={() => move(-1)} className="w-10 h-10 rounded-full bg-white shadow flex items-center justify-center text-navy"><ChevronLeft size={20} /></button>
            <span className="text-sm text-navy/60 font-semibold">{active + 1} / {TESTIMONIALS.length}</span>
            <button onClick={() => move(1)} className="w-10 h-10 rounded-full bg-white shadow flex items-center justify-center text-navy"><ChevronRight size={20} /></button>
          </div>
        </div>
      </div>
    </section>
  );
};

const Card = ({ t, i, delay = 0 }) => (
  <Reveal delay={delay}>
    <div className="bg-white rounded-2xl p-6 shadow-sm hover:shadow-lg transition-shadow h-full flex flex-col border border-gray-100">
      <Quote size={30} className="text-orange-brand/30 mb-3" />
      <p className="text-navy/70 text-sm leading-relaxed flex-1">{t.text}</p>
      <div className="flex items-center gap-3 mt-5 pt-5 border-t border-gray-50">
        <span className="w-11 h-11 rounded-full flex items-center justify-center text-white font-bold text-sm" style={{ background: colors[i % colors.length] }}>
          {initials(t.name)}
        </span>
        <div>
          <p className="font-semibold text-navy text-sm font-head">{t.name}</p>
          <p className="text-xs text-navy/50">{t.role}</p>
        </div>
      </div>
    </div>
  </Reveal>
);

export default TestimonialsSection;
